import {observable} from 'mobx';
import {construct, ModelProperties} from 'utils';

export class ContentOverride {
    @observable id!: number;

    @observable url!: string;
    @observable requiredMatch!: string;
    @observable htmlQuery!: string;
    @observable newContent!: string;

    constructor(contentOverride?: ModelProperties<ContentOverride>) {
        if (contentOverride) {
            construct(this, contentOverride);
        }
    }
}